import React, { useState, useEffect, Fragment } from "react";
import { ApiCall, Colors } from "../../common/Const";
import Footer from "../pages/Footer";
import Header from "../pages/Header";
import "../../styles/AuthStyle.css";
import TextBox from "../pages/TextBox";
import { Link, useNavigate } from "react-router-dom";
import String from "../../lang/String";
import { images } from "../../common/Images";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MutatingDots } from "react-loader-spinner";
import EncryptDecrypt from "../../common/Crypto";
import store from "../../redux/Store";
import OtpInput from 'react18-input-otp';

function Login() {
  const [email, inputChange] = useState("");
  const [login_error, setLoginError] = useState({
    email_error: " ",
  });
  const [otpStage, setotpStage] = useState(false);
  const [otpRes, setOtpRes] = useState("");
  const navigate = useNavigate();
  const [loader, setloader] = useState(false);
  const [valOtp, setvalOtp] = useState("")
  const [otpVal, setotpVal] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
  });
  const [BtnLoad, setBtnLoad] = useState(false);
  const [ApiBtnLoad, setApiBtnLoad] = useState(false);
  useEffect(() => {
    let isAuth = localStorage.getItem("customerId");
    if (isAuth && isAuth !== null) {
      navigate("/");
    }
  }, []);
  // useEffect(() => {
  //   if(BtnLoad){
  //     setBtnLoad(false)
  //   }
  // }, [otpRes])
  
  const prefixImg = (src) => {
    return (
      <div
        className="p-2"
        style={{ borderRight: `2px solid ${Colors.Base_color}` }}
      >
        <i class="fa-solid fa-envelope" style={{
          fontSize:'17px',
          color:Colors.Base_color
        }}></i>
        {/* <img
          src={src}
          className=""
          height={25}
          width={25}
          style={{ objectFit: "contain" }}
        /> */}
      </div>
    );
  };

  const loginValidation = () => {
    let isValid = true;
    setLoginError({});
    if (email == "") {
      isValid = false;
      setLoginError((prevError) => ({
        email_error: String.login.enter_email,
      }));
    }

    if (email !== "") {
      let lastAtPos = email.lastIndexOf("@");
      let lastDotPos = email.lastIndexOf(".");

      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          email.indexOf("@@") == -1 &&
          lastDotPos > 2
        )
      ) {
        isValid = false;
        setLoginError((prevError) => ({
          email_error: "Enter Valid Email",
        }));
      }
    }

    return isValid;
  };
  const loginFun = (e) => {
    e.preventDefault();
    // setloader(true);
    if (loginValidation()) {
      setBtnLoad(true)
      const loginParams = {
        email: email,
      };
      ApiCall("loginOtp", loginParams)
        .then((data) => {
          console.log("response otp-->", data);
          if (data.message == "Mail sent successfully") {
            // setloader(false);
            toast.success(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setOtpRes(data.otp);
            setotpStage(true);
          } else {
            setBtnLoad(false)
            // setloader(false);
            toast.error(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((err) => console.log(err));
    }
    // console.log("val -->", email);
  };

  const OtpVerifyFun = (e) => {
    e.preventDefault();
    // const otpState = Object.values(otpVal).toString().replace(/,/g, "");
    // setloader(true);
    setApiBtnLoad(true)
    if (otpRes == valOtp) {
      const loginParams = {
        email: email,
      };
      ApiCall("auth/login", loginParams)
        .then((data) => {
          console.log("response -->", data);
          if (data.message == "Success.") {
            // setloader(false);
            store.dispatch({ type: "login", payload: data.result });
            localStorage.setItem("first_name", data.result.first_name);
            // localStorage.setItem('user_profile', JSON.stringify(data.result))
            toast.success("Login Successfully", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let loginData =  {
              id: data.result.id,
              first_name :  data.result.first_name,
              last_name:  data.result.last_name,
              email:  data.result.email,
              phone_number: data.result.phone_number,
              avatar: data.result.avatar,
              userType: 0 // Normal user = 0, Guest user = 1
            };
            store.dispatch({ type: "addData", payload: loginData });
            setTimeout(async function () {
              let cus_id = data.result.id;
              let type = "encrypt";
              let format = "text";

              await EncryptDecrypt(cus_id, type, format, (callback) => {
                localStorage.setItem("customerId", callback);
              });

              await EncryptDecrypt(
                data.result.access_token,
                type,
                format,
                (callback) => {
                  localStorage.setItem("access_token", callback);
                }
              );
            }, 3000);
             setTimeout(() => {
              navigate("/");
              setOtpRes("");
            setotpStage(false);
            }, 2000);
            
          } else {
            console.log("else")
            // setloader(false);
            setApiBtnLoad(false)
            toast.error(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((err) => console.log(err));
    } else {
      setApiBtnLoad(false)
      // setloader(false);
      toast.error("Enter Correct OTP", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  // const handleOtpChange = (val, e) => {
  //   let updateVal = { [val]: e.target.value };
  //   setotpVal((otpval) => ({
  //     ...otpval,
  //     ...updateVal,
  //   }));
  // };

  const handleOtpChange = (enteredOtp) => {
    // console.log(enteredOtp)
    setvalOtp(enteredOtp);
  }
  // const inputfocus = (elmnt) => {
  //   if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
  //     const next = elmnt.target.tabIndex - 2;
  //     if (next > -1) {
  //       elmnt.target.form.elements[next].focus();
  //     }
  //   } else if (elmnt.target.value.length > 1) {
  //     // console.log("hello");
  //   } else {
  //     // console.log("next");

  //     const next = elmnt.target.tabIndex;
  //     if (next < 5) {
  //       elmnt.target.form.elements[next].focus();
  //     }
  //   }
  // };
  return loader ? (
    <div className="d-flex align-items-center justify-content-center ban-box">
      <MutatingDots
        height="100"
        width="100"
        color={Colors.Base_color}
        secondaryColor={Colors.Base_color}
        radius="12.5"
        ariaLabel="mutating-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  ) : (
    <>
      <Header make={true} />
      <div
        className="d-flex justify-content-center align-items-center flex-column white-box"
        style={{ backgroundColor: Colors.bg_color }}
      >
        <div
          className="form-box-login d-flex justify-content-center align-items-center flex-column p-4"
          style={{ backgroundColor: Colors.white_color }}
        >
          <p className="login-hd"> {otpStage ? "Verify OTP" : "Login"} </p>
          <span
            className=""
            style={{ color: "gray", fontFamily: "AvenirLTStdMedium" }}
          >
            {otpStage
              ? `Enter your OTP sent to registered email ! - ${otpRes}`
              : "Enter Your email!"}
          </span>
          <div className="inner-form-login">
            <div className="field-box my-3">
              {otpStage ? (
                <form>
                  <div className="d-flex align-items-center justify-content-center my-2">
                  <OtpInput value={valOtp} onChange={handleOtpChange} numInputs={5} separator={<span className="m-1"></span>} isInputNum={true} inputStyle={{
                    border: `1px solid ${Colors.Base_color}`,
                    borderRadius: "4px",
                    width: "40px",
                    height: "40px",
                    fontSize: "14px",
                    color: Colors.Base_color,
                    fontWeight: "400",
                    // caretColor: "blue"
                  }}
                  focusStyle={{
                    border: `1px solid ${Colors.Base_color}`,
                    outline: 'none'
                  }} />
                    {/* <input
                      name="otp1"
                      type="number"
                      autoComplete="off"
                      className="otpInput text-center"
                      value={otpVal.otp1}
                      // onKeyPress={this.keyPressed}
                      onChange={(e) => handleOtpChange("otp1", e)}
                      tabIndex="1"
                      maxLength={1}
                      onKeyUp={(e) => inputfocus(e)}
                      // max='1'
                    />
                    <input
                      name="otp2"
                      type="number"
                      autoComplete="off"
                      className="otpInput text-center"
                      value={otpVal.otp2}
                      onChange={(e) => handleOtpChange("otp2", e)}
                      tabIndex="2"
                      maxLength={1}
                      onKeyUp={(e) => inputfocus(e)}
                      // max='1'
                    />
                    <input
                      name="otp3"
                      type="number"
                      autoComplete="off"
                      className="otpInput text-center"
                      value={otpVal.otp3}
                      onChange={(e) => handleOtpChange("otp3", e)}
                      tabIndex="3"
                      maxLength={1}
                      onKeyUp={(e) => inputfocus(e)}
                      // max='1'
                    />
                    <input
                      name="otp4"
                      type="number"
                      autoComplete="off"
                      className="otpInput text-center"
                      value={otpVal.otp4}
                      onChange={(e) => handleOtpChange("otp4", e)}
                      tabIndex="4"
                      maxLength={1}
                      onKeyUp={(e) => inputfocus(e)}
                      // max='1'
                    />

                    <input
                      name="otp5"
                      type="number"
                      autoComplete="off"
                      className="otpInput text-center"
                      value={otpVal.otp5}
                      onChange={(e) => handleOtpChange("otp5", e)}
                      tabIndex="5"
                      maxLength={1}
                      onKeyUp={(e) => inputfocus(e)}
                    /> */}
                  </div>
                </form>
              ) : (
                <Fragment>
                <TextBox
                  type={"text"}
                  prefix={prefixImg(images.emailIcon)}
                  place={"Email"}
                  change={inputChange}
                  input_value={email}
                  name={"email"}
                />
                  <span style={{color:'red', height: '50px', float: 'right'}}>{login_error.email_error}</span>
                </Fragment>
              )}
            </div>
          </div>
          {/* {true ? ( */}
          {otpStage ? (
            !ApiBtnLoad ?
            <button
              className="btn text-center px-5"
              style={{
                backgroundColor: Colors.Base_color,
                fontSize: "22px",
                color: Colors.white_color,
              }}
              onClick={OtpVerifyFun}
            >
              Verify OTP
            </button> : <button
              className="btn text-center px-5"
              style={{
                backgroundColor: Colors.Base_color,
                fontSize: "22px",
                color: Colors.white_color,
                cursor: 'wait'
              }}
            >
              Loading...
            </button>
          ) : (
            !BtnLoad ? <button
              className="btn text-center px-5"
              style={{
                backgroundColor: Colors.Base_color,
                fontSize: "22px",
                color: Colors.white_color,
              }}
              onClick={loginFun}
            >
              Get Otp
            </button> : <button
            className="btn text-center px-5"
            style={{
              backgroundColor: Colors.Base_color,
              fontSize: "22px",
              color: Colors.white_color,
              cursor: 'wait'
            }}
            // onClick={loginFun}
          >
            Loading...
          </button>
          )}

          <div
            className="mt-3"
            style={{ fontFamily: "AvenirLTStdMedium", color: "gray" }}
          >
            Don't have an account{" "}
            <Link
              to={`/register`}
              style={{ textDecoration: "none", color: Colors.Base_color }}
            >
              Sign Up
            </Link>
          </div>
        </div>

        <ToastContainer />
      </div>
      <Footer />
    </>
  );
}

export default Login;
